var styledFooter = 'footer_styledFooter__138v3l50';

export { styledFooter };
//# sourceMappingURL=footer.vanilla.mjs.map
